module.exports = __webpack_public_path__ + "static/media/DNDicon.f5a0a8d6.svg";